import { Delegate } from "dom-delegate";
import smoothScroll from "smoothscroll";

export default {
    init: (button) => {
        const listener = new Delegate(button);

        listener.on("click", () => {
            smoothScroll(0, 1000);
        });
    },
};
